// Админы цэс — ажлаар бүлэглэсэн. Цэс бүр perm: [модуль, хамгийн бага түвшин] — эрх нь "Эрх ба роль"-оос (баазаас) ирнэ.
// Хуучин тусдаа хуудсууд (ирц, элсэлт, төлбөр, хуваарь, тохиргоо) нэг хуудасны таб болсон.
import {
  BiBarChartAlt2,
  BiBook,
  BiBot,
  BiBuildings,
  BiCalendar,
  BiCalendarCheck,
  BiCalendarEvent,
  BiCheckSquare,
  BiListUl,
  BiSpreadsheet,
  BiStar,
  BiCog,
  BiDoorOpen,
  BiError,
  BiHistory,
  BiEditAlt,
  BiFlag,
  BiGridAlt,
  BiGroup,
  BiHomeAlt,
  BiAward,
  BiLayer,
  BiMessageSquareDetail,
  BiReceipt,
  BiShieldQuarter,
  BiSun,
  BiChild,
  BiUser,
  BiUserPlus,
  BiWallet,
} from "react-icons/bi";
import { Link } from "react-router-dom";

const icon = (I) => <I size={17} className="inline" />;
const item = (key, label, to, I, perm) => ({ key, label: <Link to={to}>{label}</Link>, icon: icon(I), perm, to });
const group = (key, label, children) => ({ key, type: "group", label, children });

const menu = [
  item("home", "Нүүр", "/", BiHomeAlt, null),
  item("students", "Сурагчид", "/students", BiUser, ["students", "own"]),
  group("g-school", "Сургууль", [
    item("classes", "Анги", "/classes", BiGridAlt, ["school", "view"]),
    item("departments", "Тэнхим", "/departments", BiBuildings, ["school", "view"]),
    item("houses", "Хаус", "/houses", BiFlag, ["school", "view"]),
    item("passion", "Passion Program", "/passion", BiStar, ["passion", "view"]),
  ]),
  group("g-learning", "Сургалт", [
    item("lms", "Хичээл", "/lms", BiBook, ["courses", "own"]),
    item("course-students", "Хичээлийн сурагчид", "/course-students", BiGroup, ["settings", "view"]),
    item("projects", "Төслүүд", "/t/pbl", BiLayer, ["projects", "own"]),
    item("exams", "Шалгалт", "/exams", BiEditAlt, ["courses", "own"]),
    item("timetable", "Хуваарь", "/timetable", BiCalendar, ["schedule", "view"]),
    item("elementary", "Бага анги", "/elementary", BiChild, ["courses", "view"]),
  ]),
  // Ирц — хуудас бүр цэсэнд шууд (жагсаалт хэлбэрээр)
  group("g-attendance", "Ирц", [
    item("att-daily", "Өдрийн ирц", "/student/attendance", BiCalendarCheck, ["attendance", "own"]),
    item("att-course", "Хичээлийн ирц", "/attendance/course", BiCheckSquare, ["attendance", "own"]),
    item("att-list", "Ирцийн жагсаалт", "/attendance/report", BiListUl, ["attendance", "view"]),
    item("att-dashboard", "Ирцийн тойм", "/attendance/dashboard", BiBarChartAlt2, ["attendance", "view"]),
    item("att-calendar", "Календарь", "/attendance/calendar", BiCalendar, ["attendance", "view"]),
    item("att-course-report", "Хичээлээр тайлан", "/attendance/course-report", BiSpreadsheet, ["attendance", "view"]),
  ]),
  group("g-parents", "Эцэг эх", [
    item("parents", "Эцэг эхчүүд", "/parents", BiGroup, ["parents", "own"]),
    item("parent-comm", "Харилцаа", "/parent-comm", BiMessageSquareDetail, ["parents", "own"]),
    item("meeting", "Уулзалт", "/meeting", BiCalendarEvent, ["parents", "own"]),
  ]),
  group("g-finance", "Элсэлт ба төлбөр", [
    item("admissions", "Элсэлт", "/admissions", BiUserPlus, ["admissions", "view"]),
    item("tuition", "Төлбөр", "/tuition", BiWallet, ["payments", "view"]),
    item("transactions", "Гүйлгээ", "/transactions", BiReceipt, ["payments", "view"]),
  ]),
  group("g-ops", "Үйл ажиллагаа", [
    item("room-booking", "Танхим захиалга", "/room-booking", BiDoorOpen, ["rooms", "view"]),
    item("daycare", "Өдөр өнжүүлэх", "/daycare", BiSun, ["daycare", "view"]),
    item("violation", "Зөрчил", "/violation", BiError, ["violations", "view"]),
    item("holistic", "Их сургуулийн өргөдөл", "/holistic/reviews", BiAward, ["university", "view"]),
  ]),
  group("g-system", "Систем", [
    item("ai", "AI чат", "/ai", BiBot, ["access", "edit"]),
    item("settings", "Тохиргоо", "/settings", BiCog, ["settings", "view"]),
    item("access", "Эрх ба роль", "/access", BiShieldQuarter, ["access", "view"]),
    item("audit", "Устгалтын лог", "/audit", BiHistory, ["access", "view"]),
  ]),
];

// Эрхээр шүүх: харах эрхгүй цэс, хоосон бүлэг алга болно
export const filterMenu = (items, can) => items.reduce((acc, it) => {
  if (it.type === "group") {
    const children = filterMenu(it.children, can);
    if (children.length) acc.push({ ...it, children });
  } else if (!it.perm || can(...it.perm)) acc.push(it);
  return acc;
}, []);

// Замаас идэвхтэй цэсний түлхүүр (хамгийн урт таарсан зам)
export const keyForPath = (path) => {
  const flat = menu.flatMap((it) => (it.type === "group" ? it.children : [it]));
  const extra = { "/lms/course": "lms", "/lms/task": "lms", "/holistic/review": "holistic" };
  const hit = flat.filter((it) => (it.to === "/" ? path === "/" : path === it.to || path.startsWith(`${it.to}/`)))
    .sort((a, b) => b.to.length - a.to.length)[0];
  if (hit) return hit.key;
  const ex = Object.keys(extra).find((p) => path.startsWith(p));
  return ex ? extra[ex] : "";
};

export const flatMenu = () => menu.flatMap((it) => (it.type === "group" ? it.children.map((c) => ({ ...c, groupLabel: it.label })) : [it]));

export default menu;
